export enum ProcessDurationAppraiseeStage {
    AppraiseeApproval = 10,
    AppraiseeApprovalDescription = 'Appraisee Approval',
    PerfomanceManagerApproval = 20,
    PerfomanceManagerApprovalDescription = 'Perfomance Manager Approval',
    DepartmentAdministratorApproval = 30,
    DepartmentAdministratorApprovalDescription = 'HR Approval',
    Active = 40,
    ActiveDescription = 'Active',
    Cancelled = 50,
    CancelledDescription = 'Cancelled',
    Completed = 60,
    CompletedDescription = 'Completed'
}

